import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    sidebarItem: {
        display: 'flex',
        color: '#A8B6C1',
        fontWeight: 500,
        fontSize: '15px',
        lineHeight: '18px'
    },
    itemSelected: {
        display: 'flex',
        backgroundColor: '#225384',
        color: '#FFF',
        fontWeight: 'bold'
    }
}));
